import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, VideoIcon, CheckCircle2Icon, MessageCircleIcon } from 'lucide-react';
import { ReviewsGallery } from '../components/ReviewsGallery';
export function ConsultatiePunctualaPage() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="pt-[64px] md:pt-[72px]" data-id="element-407">
      {/* SECȚIUNEA 1 — HERO */}
      <section className="bg-brand-beige section-padding" data-id="element-408">
        <div className="container-custom" data-id="element-409">
          <div className="max-w-4xl mx-auto text-center" data-id="element-410">
            <span className="inline-block px-4 py-1.5 rounded-full bg-brand-coral/10 text-brand-coral font-montserrat font-bold text-[12px] tracking-wider uppercase mb-6" data-id="element-411">
              CONSULTAȚIE PUNCTUALĂ
            </span>
            <h1 className="font-playfair text-[40px] md:text-[56px] font-bold text-brand-navy mb-6 leading-tight" data-id="element-412">
              Primește răspunsurile de care ai nevoie
            </h1>
            <p className="font-source text-[18px] text-brand-textSecondary mb-10 max-w-3xl mx-auto" data-id="element-413">
              Ai o întrebare specifică despre dezvoltarea copilului tău? Vrei să
              știi cum să gestionezi o anumită situație sau un comportament?
              Programează o întâlnire online scurtă și la obiect.
            </p>

            <div className="bg-white p-6 rounded-[24px] shadow-sm border border-gray-100 grid grid-cols-1 sm:grid-cols-3 gap-6 mb-10 text-left" data-id="element-414">
              <div className="flex flex-col gap-2" data-id="element-415">
                <ClockIcon className="text-brand-coral" size={24} data-id="element-416" />
                <p className="font-montserrat font-bold text-[14px] text-brand-navy" data-id="element-417">
                  Durată
                </p>
                <p className="font-source text-[13px] text-brand-textSecondary" data-id="element-418">
                  30 minute
                </p>
              </div>
              <div className="flex flex-col gap-2" data-id="element-419">
                <VideoIcon className="text-brand-coral" size={24} data-id="element-420" />
                <p className="font-montserrat font-bold text-[14px] text-brand-navy" data-id="element-421">
                  Format
                </p>
                <p className="font-source text-[13px] text-brand-textSecondary" data-id="element-422">
                  Online, pe Zoom. Întâlnire 1:1 cu părintele.
                </p>
              </div>
              <div className="flex flex-col gap-2" data-id="element-423">
                <MessageCircleIcon className="text-brand-coral" size={24} data-id="element-424" />
                <p className="font-montserrat font-bold text-[14px] text-brand-navy" data-id="element-425">
                  Preț
                </p>
                <p className="font-source text-[13px] text-brand-textSecondary" data-id="element-426">
                  <span className="font-bold text-brand-coral" data-id="element-427">250 lei</span>
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center gap-3" data-id="element-428">
              <a href="#inscriere" className="btn-primary" data-id="element-429">
                Click aici pentru înscriere!
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 2 — CE PRIMEȘTI */}
      <section className="bg-brand-ivory section-padding" data-id="element-430">
        <div className="container-custom" data-id="element-431">
          <div className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-[24px] shadow-sm" data-id="element-432">
            <h2 className="font-playfair text-[28px] md:text-[36px] font-bold text-brand-navy mb-8 text-center" data-id="element-433">
              Ce se întâmplă în această consultație:
            </h2>
            <ul className="space-y-4" data-id="element-434">
              {['Întâlnire online de 30 de minute cu părintele', 'Răspund la toate întrebările la care ai nevoie de claritate', 'Analizez interacțiunea dintre părinte și copil dacă e cazul', 'Tot ce ai nevoie îți spun pe loc, online, fără așteptare'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-435">
                  <CheckCircle2Icon className="text-brand-coral flex-shrink-0 mt-0.5" size={24} data-id="element-436" />
                  <span className="font-source text-[16px] md:text-[18px] text-brand-text" data-id="element-437">
                    {item}
                  </span>
                </li>)}
            </ul>
            <div className="mt-10 text-center" data-id="element-438">
              <a href="#inscriere" className="btn-primary inline-block" data-id="element-439">
                Click aici pentru înscriere!
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 3 — CINE SUNT EU */}
      <section className="bg-brand-beige section-padding" data-id="element-440">
        <div className="container-custom" data-id="element-441">
          <div className="max-w-4xl mx-auto" data-id="element-442">
            <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy text-center mb-10" data-id="element-443">
              Cine te va ghida
            </h2>
            <div className="flex flex-col-reverse md:grid md:grid-cols-3 gap-8 items-stretch" data-id="element-444">
              <div className="md:col-span-2 font-source text-[16px] md:text-[18px] text-brand-text space-y-4 text-center md:text-left flex flex-col justify-center" data-id="element-445">
                <p data-id="element-446">
                  Sunt Cristina Geană, psiholog clinician cu peste 11 ani de
                  experiență directă cu copii mici. Am evaluat și coordonat
                  intervenția pentru sute de copii cu întârzieri în dezvoltare
                  și tulburări din spectrul autist.
                </p>
                <p data-id="element-447">
                  Sunt formată în Analiză Comportamentală (ABA) la Universitatea
                  Clemson din SUA, atestată de Colegiul Psihologilor din România
                  și am zeci de cursuri în logopedie, terapie senzorială și
                  evaluarea copilului cu cerințe educative speciale.
                </p>
              </div>
              <div className="md:col-span-1" data-id="element-448">
                <img src="https://cdn.magicpatterns.com/uploads/wvUBHAy6VhqaRqNiVJPB6X/Cristina_poze_%285%29.jpg" alt="Cristina Geană" className="w-full h-full object-cover object-top rounded-[24px] shadow-card" data-id="element-449" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 4 — OFERTĂ */}
      <EnrollmentOffer title="Ce primești și care este investiția ta" includes={['Întâlnire online de 30 de minute cu Cristina', 'Răspunsuri directe la întrebările tale', 'Analiza interacțiunii părinte-copil (dacă este cazul)', 'Claritate și direcție imediată']} price="250 lei" data-id="element-450" />

      {/* SECȚIUNEA 5 — TESTIMONIALE */}
      <section className="bg-brand-ivory section-padding" data-id="element-451">
        <div className="container-custom" data-id="element-452">
          <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy text-center mb-12" data-id="element-453">
            Ce spun mamele care deja au lucrat cu mine
          </h2>
          <ReviewsGallery data-id="element-454" />
        </div>
      </section>

      {/* SECȚIUNEA 6 — FAQ */}
      <FAQSection faqs={[{
      q: 'Trebuie să fie și copilul prezent?',
      a: 'Nu este obligatoriu. Dacă ai întrebări specifice despre comportamentul lui, putem discuta doar noi două.'
    }, {
      q: 'Ce se întâmplă dacă am nevoie de mai mult timp?',
      a: 'Dacă situația necesită o analiză mai aprofundată, te voi îndruma către o evaluare completă sau către programul potrivit.'
    }]} data-id="element-455" />

      {/* SECȚIUNEA 7 — ÎNSCRIERE */}
      <section id="inscriere" className="bg-brand-navy section-padding text-center text-white" data-id="element-456">
        <div className="container-custom" data-id="element-457">
          <div className="max-w-3xl mx-auto" data-id="element-458">
            <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-white mb-6" data-id="element-459">
              Programează consultația punctuală
            </h2>

            <div className="bg-white rounded-[24px] overflow-hidden min-h-[600px]" data-id="element-460">
              <iframe src="https://api.leadconnectorhq.com/widget/form/lCLLtJUawQDDOHSNXiwg" style={{
              width: '100%',
              height: '100%',
              minHeight: '600px',
              border: 'none'
            }} id="inline-lCLLtJUawQDDOHSNXiwg" data-layout="{'id':'INLINE'}" data-trigger-type="alwaysShow" data-trigger-value="" data-activation-type="alwaysActivated" data-activation-value="" data-deactivation-type="neverDeactivate" data-deactivation-value="" data-form-name="Form Consultatie" data-height="600" data-layout-iframe-id="inline-lCLLtJUawQDDOHSNXiwg" data-form-id="lCLLtJUawQDDOHSNXiwg" title="Form Consultatie" data-id="element-461" />
            </div>
          </div>
        </div>
      </section>
    </motion.div>;
}